<template>
  <section id="process" class="section bg-white dark:bg-dark-bg relative overflow-hidden">
    <!-- Background Decoration -->
    <div class="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-accent/5 to-transparent pointer-events-none"></div>

    <div class="container-custom relative z-10">
      <!-- Section Header -->
      <div class="text-center mb-16 animate-reveal">
        <h2 class="text-4xl md:text-5xl font-display font-bold text-gray-900 dark:text-white mb-4">
          How We Work
        </h2>
        <p class="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
          Our proven methodology for delivering exceptional results
        </p>
      </div>

      <!-- Process Steps with Timeline -->
      <div class="relative mb-24">
        <!-- Timeline connector for desktop -->
        <div class="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-accent/20 via-accent/40 to-accent/20 transform -translate-x-1/2"></div>

        <div class="space-y-8 lg:space-y-16 stagger-children">
          <div
            v-for="(step, index) in processSteps"
            :key="step.id"
            :class="[
              'process-step-item',
              index % 2 === 0 ? 'lg:pr-[52%]' : 'lg:pl-[52%]'
            ]"
          >
            <ProcessStepCard
              :number="step.number"
              :title="step.title"
              :description="step.description"
              :activities="step.activities"
              :icon="step.icon"
              :show-connector="index < processSteps.length - 1"
            />
          </div>
        </div>
      </div>

      <!-- Core Values Section -->
      <div>
        <h3 class="text-3xl md:text-4xl font-display font-bold text-gray-900 dark:text-white text-center mb-12">
          What Sets Us Apart
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 stagger-children">
          <ValueCard
            v-for="value in values"
            :key="value.id"
            :icon="value.icon"
            :title="value.title"
            :description="value.description"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ProcessStepCard from '@/components/ui/ProcessStepCard.vue';
import ValueCard from '@/components/ui/ValueCard.vue';
import { processSteps, values } from '@/data/process.js';
</script>
